import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';
import {Panel, FormLayout} from 'components';

const Review = observer(({uiState}) => {
  return (
    <div>
      <Panel.Header
        title={t('time_off.policy.edit.Review')}
        description={t('time_off.policy.edit.Review your time off policy details to ensure everything is in order. Click on the sections to make changes.')}
      />
      <FormLayout>
        <div></div>
      </FormLayout>
    </div>
  );
});

export default Review;


